<template>
  <form @submit.prevent="submit">

    <div>
      <ion-item v-for="field in fields" :key="field.name">
        <ion-label v-if="field.type!=='address'">
          {{ field.label }}
        </ion-label>
        <AddressField v-if="field.type==='address'" :value="values[field.name]" @change="values[field.name]=$event"/>
        <ion-input v-else slot="end"
                   v-model="values[field.name]" :disabled="loading" :type="field.type"/>
      </ion-item>
    </div>

    <div class="ion-padding">
      <ion-button :disabled="loading" color="success" expand="full" fill="solid" type="submit">
        <ion-spinner v-if="loading"/>
        <span v-else>
           {{ $t('global.save') }}
        </span>
      </ion-button>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { IonButton, IonInput, IonItem, IonLabel, IonSpinner } from "@ionic/vue";

import AddressField from "@/components/forms/ui/AddressField.vue";

export default defineComponent({
  components: {IonItem, IonLabel, IonInput, IonButton, IonSpinner, AddressField},
  data() {
    return {
      fields: [{
        name: "name",
        label: this.$t('forms.provider.name'),
        type: "text",
        value: ""
      }, {
        name: "email",
        label: this.$t('forms.provider.email'),
        type: "email",
        value: ""
      }, {
        name: "vat_number",
        label: this.$t('forms.provider.vat_number'),
        type: "text",
        value: ""
      }, {
        name: "iban_number",
        label: this.$t('forms.provider.iban_number'),
        type: "text",
        value: ""
      }, {
        name: "billing_address",
        label: this.$t('forms.provider.billing_address'),
        type: "address",
        value: ""
      }],
      values: {
        name: "",
      },
      loading: false
    };
  },
  emits: ['done'],
  methods: {
    submit() {
      this.loading = true;
      this.axios.put('providers', this.values).then((response) => {
        const data = response.data;
        this.loading = false;
        this.$emit('done', data);
      }).catch(() => {
        this.loading = false;
      });
    }
  }
});
</script>